import type { ReactNode } from 'react';

import type { ImageVariant, ShapeVariant } from '../ui/ResultModal';
import { ResultCounter, ResultPrizeName } from '../ui/ResultModal';

export type ResultVariantId =
  | 'daily-oops'
  | 'daily-uspeh'
  | 'weekly-other'
  | 'weekly-second'
  | 'weekly-first'
  | 'monthly-main'
  | 'monthly-second'
  | 'monthly-other'
  | 'monthly-first';

export interface ResultVariant {
  shape: ShapeVariant;
  image: ImageVariant;
  title: string;
  body: ReactNode;
  score?: ReactNode;
  caption?: ReactNode;
}

/**
 * Девять раскладок итогов (533:64142 дневные, 533:64143 недельные,
 * 533:64170 месячные). ResultModalHost подставляет факты сервера;
 * значения каталога используются для локального просмотра ?result=<id>
 * (см. ResultModalDebug), значения id — ключи этого объекта.
 */
export const RESULT_VARIANTS: Record<ResultVariantId, ResultVariant> = {
  'daily-oops': {
    shape: 'oops',
    image: 'ball',
    title: 'Прогноз не зашёл',
    body: (
      <>
        Ничего страшного, Месси тоже
        <br />
        не в каждом матче забивает
      </>
    ),
  },
  'daily-uspeh': {
    shape: 'uspeh',
    image: 'composition',
    title: 'Твои прогнозы зашли',
    body: 'А ты хорош, получай очки:',
    score: <ResultCounter icon="points" value="10" />,
  },
  'weekly-other': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 999 месте',
    body: 'Общайся в чате и делай прогнозы, так ты сможешь забраться ещё выше',
  },
  'weekly-second': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 6 месте',
    body: (
      <>
        Отработал как надо, и в атаке,
        <br />и в защите. Награда твоя
      </>
    ),
    score: <ResultCounter icon="points" value="1000" />,
  },
  'weekly-first': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 1 месте',
    body: (
      <>
        Отработал как надо, и в атаке,
        <br />и в защите. Награда твоя.
      </>
    ),
    score: (
      <>
        <ResultCounter icon="points" value="1000" />
        <ResultCounter icon="freebets" value="100 000" />
      </>
    ),
    caption: 'Как забрать фрибеты рассказали в боте',
  },
  'monthly-main': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 8 месте',
    body: 'И выиграл главный приз сентября',
    score: (
      <>
        <ResultPrizeName>PS5 SLIM</ResultPrizeName>
        <ResultCounter icon="freebets" value="100 000" />
      </>
    ),
    caption: (
      <>
        Как вывести фрибеты, рассказали в боте.
        <br />
        Для передачи приза мы свяжемся с тобой в личных
        <br />
        сообщениях с аккаунта @BETBOOM_admin_sport
      </>
    ),
  },
  'monthly-second': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 999 месте',
    body: (
      <>
        Поздравляем с победой
        <br />в розыгрыше за сентябрь
      </>
    ),
    score: <ResultCounter icon="freebets" value="100 000" />,
    caption: (
      <>
        Как вывести фрибеты, рассказали
        <br />в боте, посмотри сообщение
      </>
    ),
  },
  'monthly-other': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 999 месте',
    body: 'Это твоё место по итогам сентября. Заберёшься ещё выше в октябре?',
  },
  'monthly-first': {
    shape: 'trophy',
    image: 'trophy',
    title: 'Ты на 1 месте',
    body: (
      <>
        Красавчик! Ты лучший игрок
        <br />
        по итогам сентября. Сможешь удержать позицию в октябре?
      </>
    ),
  },
};
